import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './reducers'
import middlewares from './middlewares'
import initialState from './initialState'
import * as Sentry from '@sentry/react'

const persistConfig = {
  key: 'coachbetter',
  storage,
  debug: process.env.NODE_ENV !== 'production',
  whitelist: ['auth'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

// Sentry middleware to capture actions and state
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // @fixme: do not capture tokens
  stateTransformer: (state) => state,
  actionTransformer: (action) => action,
})

// Create the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: middlewares,
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  enhancers: (defaultEnhancers) => [...defaultEnhancers, sentryReduxEnhancer],
})

export const persistor = persistStore(store)
